import {createAction} from '@reduxjs/toolkit';

export const initialState = {
  language: 'en',
};

export const typeLanguage = createAction('root/typeLanguage');